import { InfoIcon } from "assets/icons";
import cn from "classnames";

import { InfoBannerProps } from "./InfoBanner.types";

import styles from "./InfoBanner.module.scss";

const InfoBanner = ({
  children,
  className,
  variant = "info"
}: InfoBannerProps) => {
  return (
    <div
      className={cn(styles.banner, styles[`banner--${variant}`], className)}
    >
      <InfoIcon className={styles.banner__icon} />
      <div className={styles.banner__text}>{children}</div>
    </div>
  );
};

export default InfoBanner;
